var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model.lazy",
        value: _vm.formValue,
        expression: "formValue",
        modifiers: { lazy: true }
      }
    ],
    staticClass: "c-textField",
    attrs: {
      type: "text",
      "ref-type": "text",
      name: _vm.formName,
      disabled: _vm.disabled,
      readonly: _vm.readonly
    },
    domProps: { value: _vm.formValue },
    on: {
      focus: function($event) {
        return _vm.$emit("focus")
      },
      blur: function($event) {
        return _vm.$emit("blur")
      },
      keyup: function($event) {
        return _vm.$emit("keyup", $event)
      },
      keydown: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        $event.preventDefault()
        $event.stopPropagation()
      },
      change: function($event) {
        _vm.formValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }